import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';

import { getLayout } from 'components/layouts/Sidebar';

import { withAuth } from 'lib/hocs/withAuth';

import EventDashboardModal from './EventDashboardModal';

import styles from './EventDashboard.module.scss';

const EventDashboard = () => {
  return (
    <>
      <Head>
        <title>Event Dashboard</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <section className={styles.EventDashboard} data-testid="EventDashboard">
        <EventDashboardModal></EventDashboardModal>
      </section>
    </>
  );
};

const EventDashboardWrapper = withAuth(EventDashboard);

export async function getServerSideProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'event-dashboard',
        'invite-popup',
      ])),
    },
  };
}
// @ts-ignore
EventDashboardWrapper.getLayout = getLayout;

export default EventDashboardWrapper;
